import { Input } from "@/components/ui/input";
import { Search, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface SearchBarProps {
	searchTerm: string;
	setSearchTerm: (term: string) => void;
}

export const SearchBar = ({ searchTerm, setSearchTerm }: SearchBarProps) => {
	const { t } = useTranslation();
	return (
		<div className="relative flex-1">
			<Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
			<Input 
				type="text"
				placeholder={t("candidates.filters.searchPlaceholder")}
				value={searchTerm}
				onChange={(e) => setSearchTerm(e.target.value)}
				className="pl-10 pr-10"
			/>
			{searchTerm && (
				<Button
					type="button"
					variant="ghost"
					size="icon"
					className="absolute right-1 top-1/2 transform -translate-y-1/2 h-8 w-8 p-0"
					onClick={() => setSearchTerm('')}
				>
					<X className="h-4 w-4" />
					<span className="sr-only">{t("candidates.filters.clearSearch")}</span>
				</Button>
			)}
		</div>
	);
};
